import React from "react";
import "../styles/AIRecipeCard.css";

interface SavedAIRecipe {
  id: string;
  title: string;
  instructions: string;
  image_url: string;
}

interface SavedAIRecipeCardProps {
  recipe: SavedAIRecipe;
  onDelete: () => void;
}

const SavedAIRecipeCard: React.FC<SavedAIRecipeCardProps> = ({
  recipe,
  onDelete,
}) => {
  return (
    <div className="ai-recipe-card full-width-card">
      <div className="ai-image-wrapper">
        <img
          src={recipe.image_url}
          alt={recipe.title}
          className="ai-recipe-image"
        />
        <div className="ai-image-label">
          <span className="ai">AI</span>
          <span className="resepti">RESEPTI</span>
        </div>
      </div>

      <div className="ai-recipe-text">
        <h3 className="recipe-title-centered">{recipe.title}</h3>

        <details>
          <summary>Näytä ohje</summary>
          <div
            className="saved-recipe-instructions"
            dangerouslySetInnerHTML={{
              __html: recipe.instructions.replace(/<h3[^>]*>.*?<\/h3>/i, ""),
            }}
          />
        </details>

        <div className="delete-recipe-wrapper">
          <button className="delete-recipe-button" onClick={onDelete}>
            Poista resepti
          </button>
        </div>
      </div>
    </div>
  );
};

export default SavedAIRecipeCard;
